import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.16667 15C12.3883 15 15 12.3883 15 9.16667C15 5.945 12.3883 3.33333 9.16667 3.33333C5.94501 3.33333 3.33333 5.945 3.33333 9.16667C3.33333 12.3883 5.94501 15 9.16667 15Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.6667 16.6667L13.375 13.375",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }